module.exports = __webpack_public_path__ + "img/w3_trash_solid_delete_black.89284f40.png";